import { useEffect, useState } from "react";

import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const pvComponents = [
    { id: '1', name: 'PV Module', type: 'PV_MODULE', "image": "/game-pics/pv-panel.png" },
    { id: '2', name: 'Inverter', type: 'INVERTER', "image": "/game-pics/inverter.png" },
    { id: '3', name: 'Battery', type: 'BATTERY', "image": "/game-pics/battery.png" },
    { id: '4', name: 'Charge Controller', type: 'CHARGE_CONTROLLER', "image": "/game-pics/charge-controller.png" },
    { id: '5', name: 'DC Breaker', type: 'DC_BREAKER', "image": "/game-pics/dc-breaker.png" },
    { id: '6', name: 'AC Breaker', type: 'AC_BREAKER', "image": "/game-pics/ac-breaker.png" },
];

const dropZones = [
    { id: 'A', label: 'PV Array', accepts: ['PV_MODULE'] },
    { id: 'B', label: 'Inverter Input', accepts: ['DC_BREAKER'] },
    { id: 'C', label: 'Battery System', accepts: ['BATTERY', 'CHARGE_CONTROLLER'] },
    { id: 'D', label: 'Inverter', accepts: ['INVERTER'] },
    { id: 'E', label: 'AC Load', accepts: ['AC_BREAKER'] },
];

export const PvAssembly = () => {
    const [placedComponents, setPlacedComponents] = useState({});
    const [draggedItem, setDraggedItem] = useState(null);
    const [usedComponents, setUsedComponents] = useState({});
    const [wrongChoices, setWronChoices] = useState([]);
    const [success, setSuccess] = useState(false);

    const handleDragStart = (e, component) => {
        setDraggedItem(component);
        e.dataTransfer.setData('text/plain', component.id);
    };

    const isAlreadyUsed = (componentId) => {
        if (usedComponents[componentId]) {
            return true
        }
        return false
    }

    const beingDragged = (component) => {
        if (draggedItem) {
            return draggedItem.id === component.id;
        }
        return false;
    }

    const isAcceptable = (component, zone) => {
        return zone.accepts.includes(component.type);
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, zoneId) => {
        e.preventDefault();
        /** extract component id as componentId from dataTransfer buffer */
        const componentId = e.dataTransfer.getData('text/plain');

        /** get the compenet with specified id: componentId  */
        const component = pvComponents.find(c => c.id === componentId);

        /** get component as zone with specified id: zoneId */
        const zone = dropZones.find(z => z.id === zoneId);

        /** if component and zone are defined and valid and zone does not already contain compenent
         * add component to placed components object as a property with label [zoneId] and value
         * component as droped component
         *  **/
        if (component && zone && !placedComponents[zone.id]) {
            setPlacedComponents(prev => ({
                ...prev,
                [zone.id]: component,
            }));

            if (!zone.accepts.includes(component.type)) {
                setWronChoices((arr) => ([...arr, component.type]));
            }

            /** if component has been used, add its object to used components array */
            setUsedComponents(prev => ({
                ...prev,
                [component.id]: component
            }))
        }
        /** reset draggedItem */
        setDraggedItem(null);
    };

    const handleExtract = (component, zone) => {
        if (zone && component) {
            const strId = zone.id;
            const { [strId]: _, ...rest } = placedComponents;
            setPlacedComponents(rest);
            delete usedComponents[component.id];
            setDraggedItem(null);
            setWronChoices((arr) => arr.filter((v) => v !== component.type));
        }
        return;
    }

    const handleDragEnd = () => {
        setDraggedItem(null);
    };

    const handleReset = () => {
        setPlacedComponents({});
        setDraggedItem(null);
        setSuccess(false);
        setUsedComponents({});
        setWronChoices([]);
    }

    useEffect(() => {
        if (
            Array.from(Object.keys(placedComponents)).length === 5 &&
            wrongChoices.length === 0
        ) {
            setSuccess(true);
        }
    }, [placedComponents, wrongChoices]);

    return (
        <div className="pv-game-container">
            <h2>Assemble the PV System</h2>
            {wrongChoices.length > 0 && (
                <h2 className="wr-choices">
                    {`Wrong components: ${wrongChoices.length}`}
                </h2>
            )}
            {success && (
                <h2 className="r-choices">
                    <img src="/congrats.gif" alt="" width={100} className="congr" />
                    You got this right!
                </h2>
            )}
            <div className="components-list">
                {pvComponents.map(component => (
                    <div
                        key={component.id}
                        className={classNames(
                            "component-box",
                            { 'dragged': beingDragged(component) },
                            { 'dropped': isAlreadyUsed(component.id) }
                        )}
                        draggable
                        onDragStart={(e) => handleDragStart(e, component)}
                        onDragEnd={handleDragEnd}
                    >
                        <span>{component.name}</span>
                        <img
                            className="component-image"
                            alt=""
                            src={component.image}
                        />
                    </div>
                ))}
            </div>
            <div className="drop-zones-container">
                {dropZones.map((zone, indx) => (
                    <div className={classNames("flx-c-rw")} key={zone.id}>
                        <div

                            className={`drop-zone ${placedComponents[zone.id] ? 'filled' : ''}`}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, zone.id)}
                        >
                            <span className="zone-label">{zone.label} ({zone.id})</span>
                            {placedComponents[zone.id] ? (
                                <div
                                    className={classNames(
                                        "placed-component",
                                        { "unacc": !isAcceptable(placedComponents[zone.id], zone) }
                                    )}
                                >
                                    
                                    <img
                                        className="component-image"
                                        alt=""
                                        src={placedComponents[zone.id].image}
                                    />
                                </div>
                            ) : (
                                <span className="placeholder">Drag a component here</span>
                            )}
                            {(placedComponents[zone.id] && !success) && (
                                <button
                                    className="canc-btn"
                                    onClick={() => handleExtract(placedComponents[zone.id], zone)}
                                >
                                    <FontAwesomeIcon icon={faClose} color="#888888" />
                                </button>
                            )}
                        </div>
                        {(indx < dropZones.length - 1) &&
                            <div className="arrow-dash">
                                {"--->"}
                            </div>
                        }
                    </div>
                ))}
            </div>
            {success && (
                <div className={classNames("flx-c-rw")} onClick={handleReset}>
                    <button className="reset-btt">Reset game</button>
                </div>
            )}
        </div>
    );
}